import { useEffect, useState } from "react";
import { AVATAR_LIST } from "../../lib/config";
import { GetDataListFromServer } from "../../lib/api";
import { queryHandler } from "../../lib/global_functions";
import { QUERY_AVATAR } from "../../lib/query_obj";
import toast from "react-hot-toast";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";

export default function AvatarForm({ closeDrawer, onSelect }) {
  const { access_token } = useSelector(
    (state) => state.user
  );
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 500,
    total: 0,
  });
  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  async function getDataList(page_number, per_page) {
    setLoading(true);
    await GetDataListFromServer(
      AVATAR_LIST,
      queryHandler(filter, QUERY_AVATAR, { page_number, per_page }),
      access_token
    )
      .then(({ data: { data: result, total } }) => {
        setPagin({ ...pagin, total });
        setList(result);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList(pagin.page_number, pagin.per_page);
  }, []);

  function selectAvatarHandler(item) {
    onSelect(item);
    closeDrawer();
  }

  return (
    <>
      <Row gutter={[0, 16]} justify={"end"}>
        <Col span={24}>
          <Row gutter={[24, 24]} justify={"space-around"}>
            {list.map((item) => (
              <Col flex={"200px"} key={item.id}>
                <div
                  onClick={() => selectAvatarHandler(item)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={item.url}
                    alt="image"
                    style={{
                      height: "200px",
                      width: "200px",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </>
  );
}
